const fragment = `
  id
  phase
  architecturalPrice
  community {
    id
    name 
  }  
`;

export const listCommunityPhases = `
  query listCommunityPhases(
    $filter: CommunityPhaseFilterInput!
  ) {
    items: listCommunityPhases(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getCommunityPhaseQuery = `
  query getCommunityPhase($id: Int!) {
    item: getCommunityPhase(id: $id) {
      ${fragment}
    }
  }
`;

export const createCommunityPhaseQuery = `
  mutation CreatePhaseCommunity(
    $input: CreateCommunityPhaseInput!
  ) {
    item: createCommunityPhase(input: $input) {
      ${fragment}
    }
  }
`;

export const updateCommunityPhaseQuery = `
  mutation UpdateCommunityPhase(
    $input: UpdateCommunityPhaseInput!
  ) {
    item: updateCommunityPhase(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteCommunityPhaseQuery = `
  mutation DeleteCommunityPhase(
    $id: Int!
  ) {
    item: deleteCommunityPhase(id: $id) {
      ${fragment}
    }
  }
`;
